import React, { Component } from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import MainDrawer from './component/MainDrawer.js';
import LoginPage from './component/LoginPage.js';

import firebase from 'firebase/app';
require("firebase/auth");
require("firebase/firestore");

const version = "2022.01.26";

class App extends Component {
  state = {
    logged_in: null,
    versionDialogOpen: false,
  };

  initAuth = () => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase.firestore()
          .collection('users')
          .doc(user.uid)
          .get()
          .then(doc => {
            this.setState({ logged_in: true })
          })
          .catch(err => {
            firebase.auth().signOut();
          });
      } else {
        // User is signed out.
        this.setState({ logged_in: false })
      }
    });
  }

  listenVersionChange = () => {
    firebase.firestore()
      .collection('config')
      .doc("version")
      .onSnapshot(doc => {
        if (doc.data().web === version) {
          if (this.state.logged_in === null) {
            this.initAuth();
          }
        } else {
          this.setState({ versionDialogOpen: true });
        }
      });
  }

  async componentDidMount() {
    firebase.initializeApp({
      apiKey: "AIzaSyAdVuyl90JAXHDg3pnbJq0VxsRXKOiTfPU",
      authDomain: "mybase-hk.firebaseapp.com",
      databaseURL: "https://mybase-hk.firebaseio.com",
      projectId: "mybase-hk",
      storageBucket: "mybase-hk.appspot.com",
      messagingSenderId: "401546158145"
    });

    // Enable offline data
    try {
      await firebase.firestore().enablePersistence()
    } catch (error) {
      switch (error.code) {
        case 'failed-precondition':
          alert('Multiple tabs open');
          break;
        case 'unimplemented':
          alert('The current browser does not support');
          break;
        default:
          break;
      }
    }

    this.listenVersionChange();
  }

  render() {
    let page = null;
    if (this.state.logged_in === true) {
      page = <MainDrawer version={version} />;
    } else if (this.state.logged_in === false) {
      page = <LoginPage />;
    } else {
      page = <LinearProgress />;
    }

    return (
      <div>
        <Dialog open={this.state.versionDialogOpen}>
          <DialogTitle>New version detected</DialogTitle>
          <DialogContent>
            <DialogContentText>Please refresh the page to get new updates</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => window.location.reload()} color="secondary">REFRESH</Button>
          </DialogActions>
        </Dialog>

        {page}
      </div>
    );
  }
}

export default App;
